"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBackdropMediaProperty = exports.backdropMediaPropertyDefinition = void 0;
exports.backdropMediaPropertyDefinition = {
    view: {
        label: 'Backdrop image',
        hint: 'This image will be used as a background. Make sure to use an image that is setting the mood for a given persons discipline.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'backdrop-media',
};
const isBackdropMediaProperty = (prop) => {
    return prop.name === exports.backdropMediaPropertyDefinition.name;
};
exports.isBackdropMediaProperty = isBackdropMediaProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFja2Ryb3AtbWVkaWEucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9iYWNrZHJvcC1tZWRpYS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxnQkFBZ0I7UUFDdkIsSUFBSSxFQUFFLDZIQUE2SDtLQUNwSTtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO1NBQ3BCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGdCQUFnQjtDQUNTLENBQUE7QUFJMUIsTUFBTSx1QkFBdUIsR0FBRyxDQUFDLElBQWtCLEVBQWlDLEVBQUU7SUFDM0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHVDQUErQixDQUFDLElBQUksQ0FBQTtBQUMzRCxDQUFDLENBQUE7QUFGWSxRQUFBLHVCQUF1QiwyQkFFbkMifQ==